var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0C6.97339 0 7.35714 0.383756 7.35714 0.857143V5.14286H11.6429C12.1162 5.14286 12.5 5.52661 12.5 6C12.5 6.47339 12.1162 6.85714 11.6429 6.85714H7.35714V11.1429C7.35714 11.6162 6.97339 12 6.5 12C6.02661 12 5.64286 11.6162 5.64286 11.1429V6.85714H1.35714C0.883756 6.85714 0.5 6.47339 0.5 6C0.5 5.52661 0.883756 5.14286 1.35714 5.14286H5.64286V0.857143C5.64286 0.383756 6.02661 0 6.5 0Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus2);
export default __webpack_public_path__ + "static/media/plus2.5299f4f61c09738d521175caf255d475.svg";
export { ForwardRef as ReactComponent };